import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { api } from '../api.js';
import { t } from '../i18n.js';

/**
 * Een blokkade voorstellen (docs/besluiten/blokkades-bouwen.md): bij een alert, op de kaart of op de pagina Blokkades.
 * Per klant een eigen blokkade. *Voorstellen* zet hem klaar voor goedkeuring; *Voorstellen en goedkeuren* staat er
 * alleen voor wie ook `blokkades.goedkeuren` heeft, en voert hem meteen uit.
 *
 * klanten: [{ id, name }] waaruit je kiest (bij één: geen keuze); ip leeg: zelf invullen.
 */
export default function BlokkadeVoorstellen({ mij, klanten, ip: vastIp = '', alert = null, reden: standaardReden = '', opKlaar }) {
  const naar = useNavigate();
  const client = useQueryClient();
  const [open, zetOpen] = useState(false);
  const [v, zetV] = useState({ tenant: String(klanten[0]?.id ?? ''), ip: vastIp, reden: standaardReden });
  const [fout, zetFout] = useState(null);
  const [bezig, zetBezig] = useState(false);
  const mag = (r) => mij.permissions.includes(r);
  if (!mag('blokkades.voorstellen') || !klanten.length) return null;
  if (!open) return <button type="button" className="btn" onClick={() => zetOpen(true)}>{t('Blokkade voorstellen…')}</button>;
  const zet = (k) => (e) => zetV((x) => ({ ...x, [k]: e.target.value }));
  const stuur = async (goedkeuren) => {
    zetFout(null); zetBezig(true);
    try {
      const r = await api.stelBlokkadeVoor({ tenant: Number(v.tenant), ip: v.ip.trim(), reden: v.reden.trim(), ...(alert ? { alert } : {}), goedkeuren });
      client.invalidateQueries({ queryKey: ['blokkades'] });
      opKlaar?.();
      naar(`/blokkades/${r.data.number}`);
    } catch (e) {
      zetFout(t(e.details ? Object.values(e.details)[0] : e.message));
      /* Voorgesteld maar goedkeuren lukte niet: de blokkade bestaat wel, en wacht. */
      client.invalidateQueries({ queryKey: ['blokkades'] });
    } finally { zetBezig(false); }
  };
  return (
    <form className="form blokvoorstel" onSubmit={(e) => { e.preventDefault(); stuur(false); }}>
      <h3 style={{ margin: 0 }}>{t('Blokkade voorstellen')}</h3>
      {fout && <div className="melder rood">{fout}</div>}
      {klanten.length > 1 && <label className="field"><span>{t('Klant')}</span>
        <select value={v.tenant} onChange={zet('tenant')}>{klanten.map((k) => <option key={k.id} value={k.id}>{k.name}</option>)}</select></label>}
      <label className="field"><span>{t('Adres')}</span>
        <input className="input mono" value={v.ip} onChange={zet('ip')} readOnly={Boolean(vastIp)} placeholder="198.51.100.7" autoComplete="off" /></label>
      <label className="field"><span>{t('Waarom')}</span>
        <textarea value={v.reden} onChange={zet('reden')} placeholder={t('Bijvoorbeeld: brute force op de VPN, 300 pogingen in een uur')} /></label>
      <p className="noot" style={{ margin: 0 }}>{t('ADTS ZERO zet het adres in het blokkeerobject van elke firewall van deze klant aan internet. Vervaltijd 24 uur, of 7 dagen als het adres eerder geblokkeerd was.')}</p>
      <div className="actions" style={{ justifyContent: 'flex-start', padding: 0 }}>
        <button className="btn primary" disabled={bezig || v.reden.trim().length < 3 || !v.ip.trim()}>{t('Voorstellen')}</button>
        {mag('blokkades.goedkeuren') && <button type="button" className="btn" disabled={bezig || v.reden.trim().length < 3 || !v.ip.trim()} onClick={() => stuur(true)}>
          {bezig ? t('Bezig…') : t('Voorstellen en goedkeuren')}</button>}
        <button type="button" className="btn" onClick={() => zetOpen(false)}>{t('Annuleren')}</button>
      </div>
    </form>
  );
}
